<template>
  <!-- <layout-card-wrap
    v-loading="loading"
    hasHeaderSlot
    style="margin-top: 15px">
    <template slot="title">账号信息</template>
    <div slot="form">
      <el-button
        type="primary"
        :loading="loading"
        @click="additem">新增</el-button>
    </div> -->
  <div>
    <el-form
      :inline="true"
      style="display:flex;justify-content: space-between;"
      @submit.native.prevent>
      <el-form-item>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="config.staffName"
          clearable=""
          placeholder="请输入员工姓名"
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
      border
      stripe
      :data="list">
      <el-table-column
        label="账号"
        :resizable="false"
        prop="account">
      </el-table-column>
      <el-table-column
        label="员工编号"
        width="80"
        :resizable="false"
        prop="staffNumber">
      </el-table-column>
      <el-table-column
        label="员工姓名"
        :resizable="false"
        prop="staffName">
      </el-table-column>
      <el-table-column
        label="部门"
        min-width="180"
        :resizable="false"
        prop="departmentNams">
      </el-table-column>
      <el-table-column
        label="职位"
        min-width="180"
        :resizable="false"
        prop="positionNames">
      </el-table-column>
      <el-table-column
        width="110"
        label="手机号码"
        :resizable="false"
        prop="mobile">
      </el-table-column>
      <el-table-column
        label="操作"
        :resizable="false"
        width="80">
        <template slot-scope="{row}">
          <el-button
            type="warning"
            @click="edititem(row)">编辑</el-button>
          <!-- <el-button
            v-if="row.isAdmin === 0"
            type="text"
            @click="deleteitem(row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="getstaffs" />
    <edit-staff-modal
      ref="staff"
      :callback="getstaffs" />
  </div>
  <!-- </layout-card-wrap> -->
</template>

<script>
import EditStaffModal from './edit-staff-modal.vue'
export default {
  name: 'StaffTable',
  components: { EditStaffModal },
  props: {},
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        staffName: ''
      },
      list: [],
      total: 0
    }
  },
  mounted() {
    // this.getstaffs()
  },
  methods: {
    additem() {
      this.$refs.staff.init({}, 'add')
    },
    edititem(row) {
      this.$refs.staff.init(row, 'update')
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.getstaffs()
    },
    getstaffs() {
      this.loading = true
      this.$store.dispatch(`staff/getstaffs`, {
        payload: {
          // vendorId: this.$route.query.vendorId,
          orgId: 100,
          ...this.config
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            i.functionsBak = JSON.parse(JSON.stringify(i.functions))
            i.functions = i.functions.map(s => s.funcId)
            i.productLinePermmisions = i.productLinePermmisions.map(s => s.productLineNo)
            i.warehousePermissions = i.warehousePermissions.map(s => s.warehouseId)
            i.departmentPermissions = i.departmentPermissions.map(s => s.departmentId)
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
